import cx from 'classnames'
import React, { Fragment } from 'react'
import useStyles from './Styles'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import { Reply } from '@material-ui/icons'
import { IProps } from './Interface'
import { Corner } from 'components/balloon'
import { Balloon } from 'components'
import { useTheme } from '@material-ui/core/styles'
import { Box, List, ListItem, Popover, Typography, Tooltip } from '@material-ui/core'

const ShareButton: React.FC<IProps> = ({
  disabled,
  pdfDisabled,
  pdfDownloading,
  showPdfOption,
  className,
  bgColor,
  corner,
  anchor,
  onCopyProfile,
  onDownloadPDF,
  onDownloadPDFHelper,
  onPopoverClose,
  onGetSocialMediaButton,
  ...props
}) => {
  const theme = useTheme()
  const classes = useStyles({ disabled })

  return (
    <Fragment>
      <Box className={cx(classes.root, className)} onClick={props.onClick}>
        <Balloon
          bgColor={disabled ? theme.palette.common.grey : bgColor ?? theme.palette.common.lightOrange}
          corner={corner}
          size={40}
        >
          <Reply className={classes.icon} />
        </Balloon>
      </Box>
      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={onPopoverClose}
        disableScrollLock
        anchorOrigin={{ vertical: 'center', horizontal: 50 }}
      >
        <List disablePadding>
          <ListItem button onClick={() => onCopyProfile()}>
            <Typography id="share-button-copy-url-label" color="textSecondary">
              Copy URL
            </Typography>
          </ListItem>
          {showPdfOption && (
            <Box display="flex" alignItems="center">
              <ListItem
                button
                disableGutters={true}
                onClick={() => onDownloadPDF()}
                disabled={pdfDisabled || pdfDownloading}
              >
                <Box pl={2} pr={1}>
                  <Typography id="share-button-download-pdf-label" color="textSecondary">
                    Download to PDF
                  </Typography>
                </Box>
              </ListItem>
              {pdfDisabled && (
                <Tooltip
                  leaveDelay={10000}
                  classes={{ tooltip: classes.tooltip }}
                  aria-label="To download to PDF, you must complete all the questions."
                  title={
                    <Typography id="share-button-download-pdf-helper" variant="subtitle2" align="center">
                      To download to PDF, you must complete all the questions
                    </Typography>
                  }
                >
                  <HelpOutlineIcon className={classes.helpIcon} onClick={() => onDownloadPDFHelper()} />
                </Tooltip>
              )}
            </Box>
          )}
        </List>
      </Popover>
    </Fragment>
  )
}

ShareButton.defaultProps = {
  disabled: true,
  pdfDisabled: true,
  pdfDownloading: false,
  showPdfOption: true,
  className: '',
  corner: Corner.BottomRight,
  onClick: () => {},
  onPopoverClose: () => {},
  onCopyProfile: () => {},
  onDownloadPDF: () => {}
}

export default ShareButton
